import { frontendURL } from '../../../../helper/URLHelper';

const typebot = accountId => ({
  parentNav: 'typebot',
  routes: [
    'typebot',
  ],
  menuItems: [],
});

export default typebot;
